export const detectLanguage = (file) => {
  let lines = file.split("msgid");
  let lineToDetect = lines[2].split("msgstr");
  return lineToDetect[0];
};